import {
  DefaultButton,
  DirectionalHint,
  PrimaryButton,
  TooltipDelay,
  TooltipHost,
} from "@fluentui/react";
import React, { useContext, useState } from "react";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import { loadHeatMap } from "../../../helpers/CornerstoneViewportService";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import HeatmapIcon from "../../../../../components/SVGComponents/HeatmapIcon";
import { toolTipStyles } from "../../../styles/styles";
import { SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST } from "../../../../../constants/Constants";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";
const defaultButtonStyles = {
  root: {
    height: "26px",
    width: "72px",
    marginRight: "10px",
    borderRadius: "0px 20px 20px 0px",
  },
  rootHovered: {
    backgroundColor: "black",
  },
  rootPressed: {
    backgroundColor: "black",
  },
};

const primaryButtonStyles = {
  root: {
    height: "26px",
    width: "72px",
    marginRight: "10px",
    borderRadius: "0px 20px 20px 0px",
  },
  rootHovered: {
    color: "white",
  },
  rootPressed: {
    color: "white",
  },
};
const HeatMapButton = ({ heatmapData, priors }) => {
  const { activeThumbnailIndex } = useContext(ThumbnailContext);
  const { setIsHeatMapEnabled,
    isHeatMapEnabled, } =
    useContext(studyviewerContext);
  const {
    activeViewportIndex,
    originalImageActiveState,
    isChildStudyActive,
    viewportSeriesData,
  } = useContext(ViewportContext);

  const handleClick = async () => {
    viewportSeriesData.map(async (data, index) => {
      if(SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(data?.modality?.trim?.()?.toUpperCase?.())){
        await loadHeatMap(
          viewportSeriesData[index]?.heatmapStack?.imageIds,
          isHeatMapEnabled,
          index
        );
      }
    })
    
  };

  if (
    viewportSeriesData[activeViewportIndex]?.heatmapStack?.imageIds[0] ===
      null ||
    viewportSeriesData[activeViewportIndex]?.heatmapStack?.imageIds[0] === "" ||
    originalImageActiveState[activeViewportIndex]
  ) {
    return (
      <>
        {/* <DefaultButton
            text="HeatMap"
            disabled= {true}
            styles={{ ...defaultButtonStyles, cursor: "not-allowed" }}
          /> */}
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={"heatmap"}
          directionalHint={DirectionalHint.bottomRightEdge}
          styles={toolTipStyles}
          content={"HeatMap"}
        >
          <span style={{  display:"flex",cursor: "not-allowed", marginLeft: "10px" }}>
            <HeatmapIcon active={false} />
          </span>
        </CustomToolTipHost>
      </>
    );
  } else {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={"heatmap"}
          directionalHint={DirectionalHint.bottomRightEdge}
          styles={toolTipStyles}
          content={"HeatMap"}
        >
          <span
            style={{ display:"flex",marginLeft: "10px" }}
            onClick={() => setIsHeatMapEnabled(!isHeatMapEnabled)}
          >
            <HeatmapIcon active={isHeatMapEnabled} />
          </span>
        </CustomToolTipHost>
      </>
    );
  }
};

export default HeatMapButton;
